import { AVIFDefaultText } from 'global-styles';
import React from 'react';
import styled from 'styled-components';
import { AVIFHeadTextComponent } from './AVIFCommonComponents';
import {
  AVIFDetailCommonContainer,
  AVIFStrongText,
  CodecDetailSubTitle,
  StyledTableHeaderText,
  StyledTableText,
} from './AVIFDetailCodec';

const AVIFEncodingSpeed = () => {
  return (
    <AVIFEncodingSpeedContainer>
      <AVIFHeadTextComponent>Encoding Speed</AVIFHeadTextComponent>

      <CodecDetailSubTitle>Hardware Platforms</CodecDetailSubTitle>
      <table>
        <thead>
          <tr>
            <StyledTableHeaderText as="th">Encoder</StyledTableHeaderText>
            <StyledTableHeaderText as="th">
              Microsoft Azure VM
            </StyledTableHeaderText>
            <StyledTableHeaderText as="th">Specs.</StyledTableHeaderText>
          </tr>
        </thead>
        <tbody>
          <tr>
            <StyledTableText as="td">
              <p>pulsar-avif</p>
            </StyledTableText>
            <StyledTableText as="td">
              <p>
                NP10
                <br />
                <a
                  href="https://learn.microsoft.com/en-us/azure/virtual-machines/np-series"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AVIFStrongText>
                    <span className="under-l">
                      NP-series - Azure Virtual Machines | Microsoft Learn
                    </span>
                  </AVIFStrongText>
                </a>
              </p>
            </StyledTableText>
            <StyledTableText as="td">
              <p>
                AMD Alveo U250 1ea + Intel(R) Xeon(R) Platinum 8171 CPU @
                2.6GHz, 10 cores
              </p>
            </StyledTableText>
          </tr>
          <tr>
            <StyledTableText as="td">
              <p>
                avifenc,
                <br />
                libjpeg-turbo
              </p>
            </StyledTableText>
            <StyledTableText as="td">
              <p>
                D32s
                <br />
                <a
                  href="https://learn.microsoft.com/en-us/azure/virtual-machines/dv3-dsv3-series#dsv3-series"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AVIFStrongText>
                    <span className="under-l">
                      Dv3 and Dsv3-series - Azure Virtual Machines | Microsoft
                      Learn
                    </span>
                  </AVIFStrongText>
                </a>
              </p>
            </StyledTableText>
            <StyledTableText as="td">
              <p>Intel(R) Xeon(R) Platinum 8370C CPU @ 2.8GHz, 32 cores</p>
            </StyledTableText>
          </tr>
        </tbody>
      </table>

      {/* kodak */}
      <div className="kodak-w">
        <CodecDetailSubTitle>Kodak (24 images of 768x512)</CodecDetailSubTitle>
        <ul>
          <AVIFDefaultText as="li">
            Encoding 24 images simultaneously (24 processes)
          </AVIFDefaultText>
          <AVIFDefaultText as="li">
            Each software encoding process is executed with 4 threads. (-j 4)
          </AVIFDefaultText>
        </ul>
        <table className="t-f-th">
          <thead>
            <tr>
              <StyledTableHeaderText as="th"></StyledTableHeaderText>
              <StyledTableHeaderText as="th">time [ms]</StyledTableHeaderText>
              <StyledTableHeaderText as="th">fps</StyledTableHeaderText>
              <StyledTableHeaderText as="th">
                CPU utilization
              </StyledTableHeaderText>
            </tr>
          </thead>
          <tbody>
            <tr>
              <StyledTableText as="td">
                <p>pulsar-avif</p>
              </StyledTableText>
              <StyledTableText as="td">
                <AVIFStrongText>
                  <span className="under-l">58.6</span>
                </AVIFStrongText>
              </StyledTableText>
              <StyledTableText as="td">
                <p>
                  <AVIFStrongText>
                    <span className="under-l">409.85</span>
                  </AVIFStrongText>
                </p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>305%</p>
              </StyledTableText>
            </tr>

            <tr>
              <StyledTableText as="td">
                <p>avifenc(aom)</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>405</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>59.26</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>3200%</p>
              </StyledTableText>
            </tr>

            <tr>
              <StyledTableText as="td">
                <p>avifenc(svt)</p>
              </StyledTableText>

              <StyledTableText as="td">
                <p>1325</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>18.11</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>3200%</p>
              </StyledTableText>
            </tr>
          </tbody>
        </table>
        <AVIFStrongText as="strong" style={{ margin: '24px 0 24px' }}>
          Note. When we tested pulsar-avif with 100 times of encoding 24 images,
          the average frame rate was increased to{' '}
          <span className="under-l">582 fps.</span>
        </AVIFStrongText>
      </div>

      <div className="clic-w">
        <CodecDetailSubTitle>
          CLIC (303 images of 2048x1320)
        </CodecDetailSubTitle>
        <ul>
          <AVIFDefaultText as="li">
            avifienc(aom): encoding 32 images simultaneously with -j 8 to encode
            303 images
          </AVIFDefaultText>
          <AVIFDefaultText as="li">
            avifenc(svt): encoding 16 images simultaneously with -j 4 to encode
            303 images
          </AVIFDefaultText>
        </ul>
        <table className="t-f-th">
          <thead>
            <tr>
              <StyledTableHeaderText as="th"></StyledTableHeaderText>
              <StyledTableHeaderText as="th">time [ms]</StyledTableHeaderText>
              <StyledTableHeaderText as="th">fps</StyledTableHeaderText>
              <StyledTableHeaderText as="th">
                CPU utilization
              </StyledTableHeaderText>
            </tr>
          </thead>
          <tbody>
            <tr>
              <StyledTableText as="td">
                <p>pulsar-avif</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>
                  <AVIFStrongText>
                    <span className="under-l">3267</span>
                  </AVIFStrongText>
                </p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>
                  <AVIFStrongText>
                    <span className="under-l">92.74</span>
                  </AVIFStrongText>
                </p>
              </StyledTableText>

              <StyledTableText as="td">
                <p>570%</p>
              </StyledTableText>
            </tr>

            <tr>
              <StyledTableText as="td">
                <p>avifenc(aom)</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>16191</p>
              </StyledTableText>

              <StyledTableText as="td">
                <p>18.71</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>3200%</p>
              </StyledTableText>
            </tr>

            <tr>
              <StyledTableText as="td">
                <p>avifenc(svt)</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>65826</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>4.60</p>
              </StyledTableText>
              <StyledTableText as="td">
                <p>3200%</p>
              </StyledTableText>
            </tr>
          </tbody>
        </table>
        <AVIFStrongText
          as="strong"
          style={{ margin: '0 0 24px', display: 'inline-block' }}
        >
          Note. When we tested pulsar-avif with 100 times of encoding 303
          images, the average frame rate was increased to{' '}
          <span className="under-l">93.5 fps.</span>
        </AVIFStrongText>
        <br />
        <AVIFDefaultText>
          Note. For the evaluation of the performance of pulsar-avif, we
          developed and used a daemon where a queue is embedded. The CPU
          utilization reported above is mostly taken by the daemon and client
          processes waiting for allocation of AVIF encoding hardware resources.
          For example, the 305% utilization to encode 24 Kodak images in
          pulsar-avif consists of 65% from daemon and 240% from 24 client
          processes (10% per process).
        </AVIFDefaultText>
      </div>

      <div className="hwd-w">
        <CodecDetailSubTitle>
          How we determined the number of threads for each process
        </CodecDetailSubTitle>
        <AVIFDefaultText>
          We picked up threads# where CPU utilization was not increased anymore,
          even if more threads were specified in the command line for encoding a
          single image.
        </AVIFDefaultText>
      </div>
    </AVIFEncodingSpeedContainer>
  );
};

export default AVIFEncodingSpeed;

const AVIFEncodingSpeedContainer = styled(AVIFDetailCommonContainer)`
  .kodak-w,
  .clic-w,
  .hwd-w {
    margin-top: 24px;
  }
  .kodak-w table,
  .clic-w table {
    margin: 24px 0;
  }
  .kodak-w table td p,
  .clic-w table td p {
    min-height: 0;
  }
`;
